export const mlayout = [
  {
    name: 'RegularBgrEntity',
    objects: [
      {
        name: 'RegBgDown',
        type: 'Image',
        width: 1310,
        height: 782,
        scale: 0.6603295068027211,
        images: ['images/main/background/static_01_land.png'],
        orientation: {
          land: {
            x: -146,
            y: -100,
          },
        },
      },
      {
        name: 'RegBgdonwP',
        type: 'Image',
        width: 1156,
        height: 1314,
        scale: 0.8140242346938775,
        images: ['images/main/background/static_01_port.png'],
        orientation: {
          port: {
            x: -202,
            y: -152,
          },
        },
      },
      {
        name: 'RegBgTop',
        type: 'Image',
        width: 1310,
        height: 782,
        scale: 0.6603295068027211,
        images: ['images/init/static_02_land.jpeg'],
        orientation: {
          land: {
            x: -146,
            y: -100,
          },
        },
      },
      {
        name: 'RegBGtopP',
        type: 'Image',
        width: 1156,
        height: 1314,
        scale: 0.8140242346938775,
        images: ['images/init/static_02_port.jpeg'],
        orientation: {
          port: {
            x: -202,
            y: -152,
          },
        },
      },
      {
        name: 'back-reg-02',
        type: 'AnimationSpine',
        width: 2084,
        height: 1920,
        animation: 'back-02-land',
        oriented: false,
        spine: 'animations/spine/back-reg/sleleton.json',
        orientation: {
          land: {
            x: 0,
            y: -200,
            scale: 0.5,
          },
          port: {
            x: -200,
            y: 0,
            scale: 0.48,
          },
        },
      },
      {
        name: 'back-reg-01',
        type: 'AnimationSpine',
        width: 2088,
        height: 1920,
        animation: 'back-01-land',
        oriented: false,
        spine: 'animations/spine/back-reg/sleleton.json',
        orientation: {
          land: {
            x: 0,
            y: -200,
            scale: 0.5,
          },
          port: {
            x: -200,
            y: 0,
            scale: 0.48,
          },
        },
      },
      {
        name: 'LogoSam',
        type: 'Image',
        width: 129.575,
        height: 124,
        direction: true,
        scale: 0.34831724960734567,
        images: ['images/main/ui/sam-koala-logotype.png'],
        orientation: {
          land: {
            x: -0.28,
            y: 31,
          },
        },
      },
      {
        name: 'LogoRegP',
        type: 'Image',
        width: 186,
        height: 178,
        scale: 0.5,
        images: ['images/main/ui/sam-koala-logotype.png'],
        orientation: {
          port: {
            x: 175,
            y: 43.67,
          },
        },
      },
      {
        name: 'rame',
        type: 'Image',
        width: 700,
        height: 427.575,
        scale: 0.5045089285714286,
        images: ['images/init/frame-reg.jpeg'],
        orientation: {
          land: {
            x: 128,
            y: 37,
          },
        },
      },
      {
        name: 'ReelP',
        type: 'Image',
        width: 558.79,
        height: 310.91,
        scale: 0.3846333333333333,
        images: ['images/init/frame-reg.jpeg'],
        orientation: {
          port: {
            x: 0,
            y: 282.5,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'FreespinsBgrEntity',
    objects: [
      {
        name: 'BackFS',
        type: 'Image',
        width: 1310,
        height: 782,
        scale: 0.6603295068027211,
        images: ['images/init/back_l_fs.jpeg'],
        orientation: {
          land: {
            x: -146,
            y: -100,
          },
        },
      },
      {
        name: 'FreespinBGP',
        type: 'Image',
        width: 740,
        height: 1160,
        scale: 0.6041241496598639,
        images: ['images/init/back_p_fs.jpeg'],
        orientation: {
          port: {
            x: -100,
            y: -100,
          },
        },
      },
      {
        name: 'LabelFS',
        type: 'Image',
        width: 153.02,
        height: 129,
        scale: 0.4448265838011227,
        images: ['images/main/background/fs-logotype.png'],
        orientation: {
          land: {
            x: -28.42,
            y: 38.1,
          },
        },
      },
      {
        name: 'back-fs-01',
        type: 'AnimationSpine',
        width: 1920,
        height: 1920,
        animation: 'fs',
        oriented: true,
        spine: 'animations/spine/back-fs/skeleton.json',
        orientation: {
          port: {
            x: -200,
            y: 50,
            scale: 0.5,
          },
          land: {
            x: 0,
            y: -200,
            scale: 0.5,
          },
        },
      },
      {
        name: 'FreeSpinReelP',
        type: 'Image',
        width: 611.82,
        height: 356.365,
        scale: 0.3852719406947839,
        images: ['images/main/background/frame.png'],
        orientation: {
          port: {
            x: -22,
            y: 260,
          },
        },
      },
      {
        name: 'FsReel',
        type: 'Image',
        width: 759.5,
        height: 482.5,
        scale: 0.49896800825593396,
        images: ['images/main/background/frame.png'],
        orientation: {
          land: {
            x: 100,
            y: 10,
          },
        },
      },
      {
        name: 'FreeSpinLogoP',
        type: 'Image',
        width: 206,
        height: 173.665,
        scale: 0.5988410184442662,
        images: ['images/main/background/fs-logotype.png'],
        orientation: {
          port: {
            x: 9,
            y: 58.17,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'ReelsEntity',
    objects: [
      {
        name: 'reel-0',
        type: 'Reel',
        x: 128.5,
        y: 50,
        width: 140,
        height: 410,
      },
      {
        name: 'reel-1',
        type: 'Reel',
        x: 268.5,
        y: 50,
        width: 140,
        height: 410,
      },
      {
        name: 'reel-2',
        type: 'Reel',
        x: 409.5,
        y: 50,
        width: 140,
        height: 410,
      },
      {
        name: 'reel-3',
        type: 'Reel',
        x: 552,
        y: 50,
        width: 140,
        height: 410,
      },
      {
        name: 'reel-4',
        type: 'Reel',
        x: 695,
        y: 50,
        width: 140,
        height: 410,
      },
      {
        name: 'mask',
        type: 'Mask',
        x: 130,
        y: 51.75,
        width: 700,
        height: 405.75,
      },
      {
        name: 'swipe',
        type: 'SpinSwipeButton',
        x: 129,
        y: 47.34,
        width: 706,
        height: 414.415,
        alpha: 0,
        runtime: { platform: 'mobile,tablet' },
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -100,
        y: 251.515,
        scale: 0.77,
      },
    },
  },
  {
    name: 'SymbolValueEntity',
    objects: [
      {
        name: 'symbol-value',
        type: 'SymbolValuePopup',
        x: 117.04,
        y: 95.29,
        width: '280',
        height: '270',
        color: '#261f32',
        texture: 'SymbolValueBack',
        scale: 1.740506329113924,
        images: [
          '../aztec/images/main/buttons/bet-button-0.png',
          '../aztec/images/main/buttons/bet-button-1.png',
        ],
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 130,
        y: 51.75,
        scale: 1,
      },
      port: {
        x: -0.87,
        y: 292.27,
        scale: 0.77,
      },
    },
  },
  {
    name: 'LinesEntity',
    objects: [
      {
        name: 'container',
        type: 'LinesContainer',
        x: 128.5,
        y: 39,
        width: 700,
        height: 420,
      },
      {
        name: 'line-win-text',
        type: 'LineWinText',
        x: 115.92,
        y: 192.81,
        width: 744.96,
        height: 150,
        fontBitmap: 'bitmap',
        letterSpacing: 35,
        text: '$10.00',
        style: {
          font: 'bitmap',
          fontFamily: 'bitmap',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 40,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 744.96,
        },
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -100,
        y: 251.5,
        scale: 0.77,
      },
    },
  },
  {
    name: 'UIFrameEntity',
    objects: [
      {
        name: 'frame',
        type: 'NineSlicePlane',
        width: 5,
        height: 50,
        from: 'atlases/footer.png',
        orientation: {
          land: {
            x: -750,
            y: 457,
            v: 1,
          },
        },
      },
      {
        name: 'frameP',
        type: 'NineSlicePlane',
        width: 5,
        height: 200,
        from: 'atlases/footer.png',
        orientation: {
          port: {
            x: -500,
            y: 850,
            v: 1,
          },
        },
      },
      {
        name: 'net',
        type: 'NineSlicePlane',
        width: 5,
        height: 50,
        from: 'atlases/net-land.png',
        orientation: {
          land: {
            x: -750,
            y: 500,
            v: 1,
          },
        },
      },
      {
        name: 'netFrameP',
        type: 'NineSlicePlane',
        width: 5,
        height: 96.97,
        from: 'atlases/net-port.png',
        orientation: {
          port: {
            x: -499.47,
            y: 937.5,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'BonusMultiplierEntity',
    objects: [
      {
        name: 'multiplier-anim',
        type: 'BonusMultiplier',
        width: 0,
        height: 0,
        direction: true,
        orientation: {
          land: {
            x: 60,
            y: 230,
            scale: 0.5,
          },
          port: {
            x: 450,
            y: 140,
            scale: 0.5,
          },
        },
      },
      {
        name: 'Bonus-name',
        type: 'BonusNameSpine',
        width: 960,
        height: 960,
        scale: 0.5,
        spine: 'animations/spine/bonus-names/skeleton.json',
        orientation: {
          port: {
            x: -200,
            y: 0,
          },
          land: {
            x: 0,
            y: -200,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'WinAnimationEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 1400,
        height: 960,
        orientation: {
          land: {
            x: -210,
            y: -210,
          },
        },
      },
      {
        name: 'stretchP',
        type: 'NoiseGraphics',
        width: 960,
        height: 1488,
        orientation: {
          port: {
            x: -208,
            y: -110,
          },
        },
      },
      {
        name: 'land',
        type: 'WinParticle',
        width: 0,
        height: 0,
        count: 8,
        isAnimate: true,
        lifetime: 3,
        offsetX: 0,
        offsetY: 0,
        particle: 'coin',
        particleName: 'coin_',
        orientation: {
          land: {
            x: 494.13,
            y: 270,
          },
        },
      },
      {
        name: 'port',
        type: 'WinParticle',
        width: 94,
        height: 68,
        count: 8,
        isAnimate: true,
        lifetime: 6,
        offsetX: 0,
        offsetY: 0,
        particle: 'coin',
        particleName: 'coin_',
        orientation: {
          port: {
            x: 268,
            y: 445.5,
          },
        },
      },
      {
        name: 'ligth',
        type: 'Image',
        width: 512,
        height: 333.5,
        scale: 0.5,
        images: ['images/main/background/light.png'],
        orientation: {
          land: {
            x: 239.84,
            y: 100.17,
          },
          port: {
            x: 18,
            y: 280.75,
          },
        },
      },
      {
        name: 'bigwins',
        type: 'BigWinTitle',
        width: 0,
        height: 0,
        scale: 0.4,
        orientation: {
          land: {
            x: 480,
            y: 270,
          },
          port: {
            x: 270,
            y: 445.5,
          },
        },
      },
      {
        name: 'you-win-big',
        type: 'BigWinCounter',
        width: 744.96,
        height: 63.5,
        fontBitmap: 'bitmap',
        letterSpacing: 35,
        text: '$10.00',
        style: {
          font: 'bitmap',
          fontFamily: 'bitmap',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 35,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 744.96,
        },
        orientation: {
          land: {
            x: 107.825,
            y: 327.45,
          },
          port: {
            x: -109.39,
            y: 630.365,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'OverReelEntity',
    objects: [
      {
        name: '0',
        type: 'OverReelAnimation',
        x: 128.67,
        y: 37.5,
        width: 140,
        height: 425,
      },
      {
        name: '1',
        type: 'OverReelAnimation',
        x: 268.67,
        y: 37.5,
        width: 140,
        height: 425,
      },
      {
        name: '2',
        type: 'OverReelAnimation',
        x: 409.67,
        y: 37.5,
        width: 140,
        height: 425,
      },
      {
        name: '3',
        type: 'OverReelAnimation',
        x: 552,
        y: 37.5,
        width: 140,
        height: 425,
      },
      {
        name: '4',
        type: 'OverReelAnimation',
        x: 695,
        y: 37.5,
        width: 140,
        height: 425,
      },
      {
        name: 'mask',
        type: 'Mask',
        x: 130.17,
        y: 39,
        width: 705,
        height: 419.5,
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -100,
        y: 251.5,
        scale: 0.77,
      },
    },
  },
  {
    name: 'MenuBackEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 960,
        height: 960,
        alpha: 0.8,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'AutoMenuEntity',
    objects: [
      {
        name: 'loss-0',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 230,
            y: 295,
          },
          port: {
            x: 143.17,
            y: 389,
          },
        },
      },
      {
        name: 'autoselected',
        type: 'Image',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: ['images/icons/button-0.png'],
        orientation: {
          port: {
            x: 213.25,
            y: 201.67,
          },
          land: {
            x: 424.29,
            y: 118.83,
          },
        },
      },
      {
        name: 'loss-1',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 359.5,
            y: 295,
          },
          port: {
            x: 275.17,
            y: 388.5,
          },
        },
      },
      {
        name: 'prevauto',
        type: 'DecreaseAutoButton',
        width: 21,
        height: 30,
        hitzone: 8,
        scale: 0.8786764705882353,
        images: [
          'images/icons/bet-left-0.png',
          'images/icons/bet-left-1.png',
        ],
        orientation: {
          port: {
            x: 56.75,
            y: 215,
          },
          land: {
            x: 266.96,
            y: 128.5,
          },
        },
      },
      {
        name: 'loss-2',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 487.5,
            y: 295,
          },
          port: {
            x: 144.84,
            y: 456.5,
          },
        },
      },
      {
        name: 'nextauto',
        type: 'IncreaseAutoButton',
        width: 20,
        height: 30,
        hitzone: 8,
        scale: 0.857843137254902,
        images: [
          'images/icons/bet-right-0.png',
          'images/icons/bet-right-1.png',
        ],
        orientation: {
          port: {
            x: 468.25,
            y: 216.25,
          },
          land: {
            x: 673.38,
            y: 128.5,
          },
        },
      },
      {
        name: 'loss-3',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 617,
            y: 295,
          },
          port: {
            x: 276.17,
            y: 454.5,
          },
        },
      },
      {
        name: 'win-0',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 230,
            y: 410,
          },
          port: {
            x: 151.34,
            y: 582.5,
          },
        },
      },
      {
        name: 'win-1',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 359,
            y: 410,
          },
          port: {
            x: 280.5,
            y: 581.5,
          },
        },
      },
      {
        name: 'win-2',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 488,
            y: 410,
          },
          port: {
            x: 148.84,
            y: 649.67,
          },
        },
      },
      {
        name: 'win-3',
        type: 'AutoButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 617,
            y: 410,
          },
          port: {
            x: 278.5,
            y: 649.67,
          },
        },
      },
      {
        name: 'win',
        type: 'AutoLimitSelectedText',
        width: 495.705,
        height: 35,
        text: 'winlimit',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 495.705,
        },
        orientation: {
          land: {
            x: 233.125,
            y: 362.165,
          },
          port: {
            x: 20.07,
            y: 532.835,
          },
        },
      },
      {
        name: 'loss',
        type: 'AutoLimitSelectedText',
        width: 480.47,
        height: 35,
        text: 'losslimit',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 480.47,
        },
        orientation: {
          port: {
            x: 31.865,
            y: 341.5,
          },
          land: {
            x: 235.08,
            y: 239.665,
          },
        },
      },
      {
        name: 'loss-0',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 230,
            y: 295,
          },
          port: {
            x: 142.665,
            y: 389.835,
          },
        },
      },
      {
        name: 'loss-1',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 359.5,
            y: 295,
          },
          port: {
            x: 276.335,
            y: 390.165,
          },
        },
      },
      {
        name: 'loss-2',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 487.5,
            y: 295,
          },
          port: {
            x: 144.335,
            y: 457.165,
          },
        },
      },
      {
        name: 'loss-3',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'noLimit',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 617,
            y: 295,
          },
          port: {
            x: 276.665,
            y: 455.5,
          },
        },
      },
      {
        name: 'win-0',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 230,
            y: 410,
          },
          port: {
            x: 149,
            y: 583,
          },
        },
      },
      {
        name: 'win-1',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 359,
            y: 410,
          },
          port: {
            x: 278,
            y: 583,
          },
        },
      },
      {
        name: 'win-2',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'adder',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 488,
            y: 410,
          },
          port: {
            x: 149,
            y: 650,
          },
        },
      },
      {
        name: 'win-3',
        type: 'AutoLimitOptionText',
        width: 113,
        height: 49.5,
        text: 'noLimit',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 617.5,
            y: 410,
          },
          port: {
            x: 278.335,
            y: 650.665,
          },
        },
      },
      {
        name: 'autoplay',
        type: 'Text',
        width: 426,
        height: 28,
        text: 'autoHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 26,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 426,
        },
        orientation: {
          land: {
            x: 263,
            y: 29,
          },
          port: {
            x: 56,
            y: 93,
          },
        },
      },
      {
        name: 'number',
        type: 'Text',
        width: 433,
        height: 35,
        text: 'numberSpins',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 26,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 433,
        },
        orientation: {
          land: {
            x: 263,
            y: 69,
          },
          port: {
            x: 56,
            y: 154,
          },
        },
      },
      {
        name: 'settings',
        type: 'Text',
        width: 429,
        height: 34.5,
        text: 'extendedSettings',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 26,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 429,
        },
        orientation: {
          land: {
            x: 267,
            y: 191.5,
          },
          port: {
            x: 56,
            y: 280,
          },
        },
      },
      {
        name: 'auto-carousel',
        type: 'AutoCarousel',
        width: 113,
        height: 47.5,
        text: '2',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 113,
        },
        orientation: {
          land: {
            x: 424.285,
            y: 118.835,
          },
          port: {
            x: 213.75,
            y: 204.5,
          },
        },
      },
      {
        name: 'ui-automenu',
        type: 'RadioButton',
        width: 55,
        height: 55,
        deselect: true,
        direction: true,
        scale: 0.5,
        images: [
          'images/icons/menu-hamburger-0.png',
          'images/icons/menu-hamburger-1.png',
        ],
        orientation: {
          land: {
            x: 658,
            y: 34,
          },
          port: {
            x: 451.84,
            y: 98.5,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'BetEntity',
    objects: [
      {
        name: 'bet',
        type: 'Text',
        width: 471.335,
        height: 35.92,
        text: 'bet',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 26.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 471.335,
        },
        orientation: {
          land: {
            x: 247.665,
            y: 44.755,
          },
          port: {
            x: 40,
            y: 162.5,
          },
        },
      },
      {
        name: 'ui-bet',
        type: 'RadioButton',
        width: 55,
        height: 55,
        deselect: true,
        direction: true,
        hitzone: 2,
        scale: 0.5,
        images: [
          'images/icons/menu-hamburger-0.png',
          'images/icons/menu-hamburger-1.png',
        ],
        orientation: {
          land: {
            x: 658.5,
            y: 30,
          },
          port: {
            x: 451.59,
            y: 165.09,
          },
        },
      },
      {
        name: 'field',
        type: 'BetField',
        width: 474.265,
        height: 356.905,
        numberOfButtons: 24,
        textPosX: 110,
        textPosY: 50,
        texture: 'button-0',
        orientation: {
          land: {
            x: 245.205,
            y: 105.34,
          },
          port: {
            x: 38.005,
            y: 246.915,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'PaytableEntity',
    objects: [
      {
        name: 'PaytableEntity-header-text',
        type: 'Text',
        x: 0,
        y: 21.5,
        width: 960,
        height: 32.835,
        text: 'paytableHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
      },
      {
        name: 'PaytableEntity-freespins-describe-text',
        type: 'Text',
        x: 508.5,
        y: 254.92,
        width: 234,
        height: 50.165,
        context: { jackpot: true },
        text: 'freespinsPayDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 234,
        },
      },
      {
        name: 'PaytableEntity-jackpot-describe-text',
        type: 'Text',
        x: 235.79,
        y: 254.87,
        width: 202,
        height: 50.165,
        context: { jackpot: true },
        text: 'jackpotPayDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 202,
        },
      },
      {
        name: 'PrevAutoPage',
        type: 'DecreasePageButton',
        x: 271.5,
        y: 465,
        width: 12,
        height: 17,
        scale: 0.5,
        images: [
          'images/main/buttons/bet-left-0.png',
          'images/main/buttons/bet-left-1.png',
        ],
      },
      {
        name: 'AutoCaruselPage',
        type: 'PageCarousel',
        x: 467.5,
        y: 465,
        width: 15,
        height: 15,
        scale: 0.5,
        images: [
          'images/main/buttons/dot-0.png',
          'images/main/buttons/dot-1.png',
        ],
      },
      {
        name: 'NextAutoPage',
        type: 'IncreasePageButton',
        x: 680,
        y: 464,
        width: 12,
        height: 17,
        hitzone: 4,
        scale: 0.5,
        images: [
          'images/main/buttons/bet-right-0.png',
          'images/main/buttons/bet-right-1.png',
        ],
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -210,
        y: 100,
        scale: 1,
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'PaytableEntity-hot-header-text',
        type: 'Text',
        x: 0,
        y: 85.85,
        width: 960,
        height: 31.165,
        text: 'hotHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
      },
      {
        name: '',
        type: 'Image',
        x: 395.41,
        y: 117,
        width: 143,
        height: 130.5,
        scale: 0.5,
        images: ['images/main/paytable/scattter.png'],
      },
      {
        name: 'PaytableEntity-scatter-describe-text',
        type: 'Text',
        x: 213.71,
        y: 291,
        width: 531.245,
        height: 111.1,
        text: 'scatterPayDescribe',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 21,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 531.245,
        },
      },
      {
        name: 'bg',
        type: 'Graphics',
        x: 238,
        y: 60,
        width: 485,
        height: 394,
        alpha: 0.01,
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -210,
        y: 100,
        scale: 1,
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'PaytableEntity-hot-header-text',
        type: 'Text',
        x: 0,
        y: 85.85,
        width: 960,
        height: 31.165,
        text: 'hotHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
      },
      {
        name: '',
        type: 'Image',
        x: 429.41,
        y: 146,
        width: 108,
        height: 82.5,
        scale: 0.5,
        images: ['images/main/paytable/wild.png'],
      },
      {
        name: 'PaytableEntity-wild-describe-text',
        type: 'Text',
        x: 235.12,
        y: 275.03,
        width: 488.645,
        height: 111.255,
        text: 'wildPayDescribe',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 21,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 488.645,
        },
      },
      {
        name: 'bg',
        type: 'Graphics',
        x: 238,
        y: 60,
        width: 485,
        height: 394,
        alpha: 0.01,
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -210,
        y: 100,
        scale: 1,
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'bonus-games-img',
        type: 'Image',
        x: 417.27,
        y: 175,
        width: 134.875,
        height: 130.12,
        scale: 0.3533156754795894,
        images: ['images/main/paytable/5-bonus-games.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 251,
        y: 175,
        width: 166,
        height: 106.5,
        scale: 0.4590963280877444,
        images: ['images/main/paytable/koala-sym.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 553.86,
        y: 175,
        width: 148.48,
        height: 121,
        scale: 0.3505507325013565,
        images: ['images/main/paytable/random.png'],
      },
      {
        name: 'game-logo-img',
        type: 'Image',
        x: 359.5,
        y: 75.74,
        width: 237.525,
        height: 83.2,
        scale: 0.6351040433522472,
        images: ['images/main/paytable/sammy-gun.png'],
      },
      {
        name: 'PaytableEntity-freespins-describe-text',
        type: 'Text',
        x: 229,
        y: 315.33,
        width: 499.775,
        height: 122.44,
        text: 'freespinsPayDescribe',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 18,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 499.775,
        },
      },
      {
        name: 'bg',
        type: 'Graphics',
        x: 238,
        y: 60,
        width: 485,
        height: 394,
        alpha: 0.01,
      },
    ],
    properties: { hitzone: 2 },
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -210,
        y: 100,
        scale: 1,
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'PaytableEntity-symbols-header-text',
        type: 'Text',
        x: 275,
        y: 75,
        width: 406,
        height: 50.165,
        text: 'symbolsHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 406,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 368,
        y: 214,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 368,
        y: 191.5,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 368,
        y: 169,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 360,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 337.5,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 315,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '1-3',
        type: 'PayoutText',
        x: 398,
        y: 214,
        width: 80,
        height: 21.5,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: '1-4',
        type: 'PayoutText',
        x: 398,
        y: 191.5,
        width: 80,
        height: 21.5,
        text: '€20.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: '1-5',
        type: 'PayoutText',
        x: 398,
        y: 169,
        width: 80,
        height: 21.5,
        text: '€500.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'A-3',
        type: 'PayoutText',
        x: 400,
        y: 360,
        width: 80,
        height: 21.5,
        text: '€25.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'A-4',
        type: 'PayoutText',
        x: 400,
        y: 337.5,
        width: 80,
        height: 21.5,
        text: '€125.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'A-5',
        type: 'PayoutText',
        x: 400,
        y: 315,
        width: 80,
        height: 21.5,
        text: '€2000.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 360,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 337.5,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 315,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: 'B-3',
        type: 'PayoutText',
        x: 640,
        y: 360,
        width: 80,
        height: 21.5,
        text: '€25.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'B-4',
        type: 'PayoutText',
        x: 640,
        y: 337.5,
        width: 80,
        height: 21.5,
        text: '€125.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'B-5',
        type: 'PayoutText',
        x: 640,
        y: 315,
        width: 80,
        height: 21.5,
        text: '€1000.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: '',
        type: 'Image',
        x: 240,
        y: 152,
        width: 119.5,
        height: 104.3,
        scale: 0.39964285714285713,
        images: ['images/main/items/static/1.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 482,
        y: 305.5,
        width: 112,
        height: 108,
        scale: 0.3928571428571429,
        images: ['images/main/items/static/B.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 243,
        y: 309,
        width: 112,
        height: 108,
        scale: 0.3928571428571429,
        images: ['images/main/items/static/A.png'],
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 382.5,
        width: 28,
        height: 21.5,
        text: '2',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: 'A-2',
        type: 'PayoutText',
        x: 400,
        y: 382.5,
        width: 80,
        height: 21.5,
        text: '€2.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 382.5,
        width: 28,
        height: 21.5,
        text: '2',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: 'B-2',
        type: 'PayoutText',
        x: 640,
        y: 382.5,
        width: 80,
        height: 21.5,
        text: '€2.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'bg',
        type: 'Graphics',
        x: 238,
        y: 60,
        width: 485,
        height: 394,
        alpha: 0.01,
      },
      {
        name: '',
        type: 'Image',
        x: 480,
        y: 144,
        width: 119.5,
        height: 119.5,
        scale: 0.42678571428571427,
        images: ['images/main/items/static/2.png'],
      },
      {
        name: '',
        type: 'Text',
        x: 609,
        y: 213,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 609,
        y: 190.5,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 609,
        y: 168,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '2-3',
        type: 'PayoutText',
        x: 639,
        y: 213,
        width: 80,
        height: 21.5,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: '2-4',
        type: 'PayoutText',
        x: 639,
        y: 190.5,
        width: 80,
        height: 21.5,
        text: '€20.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: '2-5',
        type: 'PayoutText',
        x: 639,
        y: 168,
        width: 80,
        height: 21.5,
        text: '€500.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -210,
        y: 100,
        scale: 1,
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'PaytableEntity-symbols-header-text',
        type: 'Text',
        x: 275,
        y: 75,
        width: 406,
        height: 50.165,
        text: 'symbolsHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 406,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 360,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 337.5,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 315,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: 'E-3',
        type: 'PayoutText',
        x: 400,
        y: 360,
        width: 80,
        height: 21.5,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'E-4',
        type: 'PayoutText',
        x: 400,
        y: 337.5,
        width: 80,
        height: 21.5,
        text: '€30.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'E-5',
        type: 'PayoutText',
        x: 400,
        y: 315,
        width: 80,
        height: 21.5,
        text: '€150.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 200,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 177.5,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 155,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 370,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 347.5,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 325,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: 'D-5',
        type: 'PayoutText',
        x: 640,
        y: 155,
        width: 80,
        height: 21.5,
        text: '€300.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'D-3',
        type: 'PayoutText',
        x: 640,
        y: 200,
        width: 80,
        height: 21.5,
        text: '€10.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'D-4',
        type: 'PayoutText',
        x: 640,
        y: 177.5,
        width: 80,
        height: 21.5,
        text: '€75.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'F-3',
        type: 'PayoutText',
        x: 640,
        y: 370,
        width: 80,
        height: 21.5,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'F-4',
        type: 'PayoutText',
        x: 640,
        y: 347.5,
        width: 80,
        height: 21.5,
        text: '€30.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'F-5',
        type: 'PayoutText',
        x: 640,
        y: 325,
        width: 80,
        height: 21.5,
        text: '€150.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: '',
        type: 'Image',
        x: 480,
        y: 304.5,
        width: 112,
        height: 108,
        scale: 0.3928571428571429,
        images: ['images/main/items/static/F.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 480,
        y: 145,
        width: 112,
        height: 108,
        scale: 0.3928571428571429,
        images: ['images/main/items/static/D.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 241,
        y: 304,
        width: 112,
        height: 108,
        scale: 0.3928571428571429,
        images: ['images/main/items/static/E.png'],
      },
      {
        name: '',
        type: 'Text',
        x: 610,
        y: 222.5,
        width: 28,
        height: 21.5,
        text: '2',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: 'D-2',
        type: 'PayoutText',
        x: 640,
        y: 222.5,
        width: 80,
        height: 21.5,
        text: '€2.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'bg',
        type: 'Graphics',
        x: 238,
        y: 60,
        width: 485,
        height: 394,
        alpha: 0.01,
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 200,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 177.5,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 155,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: 'C-3',
        type: 'PayoutText',
        x: 400,
        y: 200,
        width: 80,
        height: 21.5,
        text: '€10.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'C-4',
        type: 'PayoutText',
        x: 400,
        y: 177.5,
        width: 80,
        height: 21.5,
        text: '€75.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'C-5',
        type: 'PayoutText',
        x: 400,
        y: 155,
        width: 80,
        height: 21.5,
        text: '€500.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: '',
        type: 'Image',
        x: 240,
        y: 143,
        width: 112,
        height: 108,
        scale: 0.3928571428571429,
        images: ['images/main/items/static/C.png'],
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 222.5,
        width: 28,
        height: 21.5,
        text: '2',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: 'C-2',
        type: 'PayoutText',
        x: 400,
        y: 222.5,
        width: 80,
        height: 21.5,
        text: '€2.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 370,
        y: 382.5,
        width: 28,
        height: 21.5,
        text: '2',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: 'E-2',
        type: 'PayoutText',
        x: 400,
        y: 382.5,
        width: 80,
        height: 21.5,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -210,
        y: 100,
        scale: 1,
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'PaytableEntity-symbols-header-text',
        type: 'Text',
        x: 275,
        y: 75,
        width: 406,
        height: 50.165,
        text: 'symbolsHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 406,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 355,
        y: 370,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 355,
        y: 347.5,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 355,
        y: 325,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: 'I-3',
        type: 'PayoutText',
        x: 385,
        y: 370,
        width: 80,
        height: 21.5,
        text: '€3.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'I-4',
        type: 'PayoutText',
        x: 385,
        y: 347.5,
        width: 80,
        height: 21.5,
        text: '€15.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'I-5',
        type: 'PayoutText',
        x: 385,
        y: 325,
        width: 80,
        height: 21.5,
        text: '€75.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 595,
        y: 210,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 595,
        y: 187.5,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 595,
        y: 165,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: 'H-3',
        type: 'PayoutText',
        x: 625,
        y: 210,
        width: 80,
        height: 21.5,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'H-4',
        type: 'PayoutText',
        x: 625,
        y: 187.5,
        width: 80,
        height: 21.5,
        text: '€20.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'H-5',
        type: 'PayoutText',
        x: 625,
        y: 165,
        width: 80,
        height: 21.5,
        text: '€125.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: '',
        type: 'Image',
        x: 241.14,
        y: 305.21,
        width: 112,
        height: 108,
        scale: 0.3928571428571429,
        images: ['images/main/items/static/I.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 480.64,
        y: 148.21,
        width: 112,
        height: 108,
        scale: 0.3928571428571429,
        images: ['images/main/items/static/H.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 480.64,
        y: 308.8,
        width: 112,
        height: 108,
        scale: 0.3928571428571429,
        images: ['images/main/items/static/J.png'],
      },
      {
        name: '',
        type: 'Text',
        x: 595,
        y: 370,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 595,
        y: 347.5,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 595,
        y: 325,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: 'J-3',
        type: 'PayoutText',
        x: 625,
        y: 370,
        width: 80,
        height: 21.5,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'J-4',
        type: 'PayoutText',
        x: 625,
        y: 347.5,
        width: 80,
        height: 21.5,
        text: '€20.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'J-5',
        type: 'PayoutText',
        x: 625,
        y: 325,
        width: 80,
        height: 21.5,
        text: '€125.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'bg',
        type: 'Graphics',
        x: 238,
        y: 60,
        width: 485,
        height: 394,
        alpha: 0.01,
      },
      {
        name: '',
        type: 'Text',
        x: 355,
        y: 210,
        width: 28,
        height: 21.5,
        text: '3',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 355,
        y: 187.5,
        width: 28,
        height: 21.5,
        text: '4',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: '',
        type: 'Text',
        x: 355,
        y: 165,
        width: 28,
        height: 21.5,
        text: '5',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 28,
        },
      },
      {
        name: 'G-3',
        type: 'PayoutText',
        x: 385,
        y: 210,
        width: 80,
        height: 21.5,
        text: '€5.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'G-4',
        type: 'PayoutText',
        x: 385,
        y: 187.5,
        width: 80,
        height: 21.5,
        text: '€20.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: 'G-5',
        type: 'PayoutText',
        x: 385,
        y: 165,
        width: 80,
        height: 21.5,
        text: '€125.00',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 80,
        },
      },
      {
        name: '',
        type: 'Image',
        x: 239.57,
        y: 146,
        width: 112,
        height: 108,
        scale: 0.3928571428571429,
        images: ['images/main/items/static/G.png'],
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -210,
        y: 100,
        scale: 1,
      },
    },
  },
  {
    name: 'PaytablePageEntity',
    objects: [
      {
        name: 'PaytableEntity-lines-header-text',
        type: 'Text',
        x: 206.71,
        y: 65,
        width: 540,
        height: 50.165,
        text: 'linesHeader',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 540,
        },
      },
      {
        name: '',
        type: 'Image',
        x: 240,
        y: 144,
        width: 80,
        height: 45,
        scale: 0.2778909231230974,
        images: ['images/main/winlines/winline1.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 340,
        y: 144,
        width: 80,
        height: 45,
        scale: 0.2778909231230974,
        images: ['images/main/winlines/winline2.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 440,
        y: 144,
        width: 80,
        height: 45,
        scale: 0.2778909231230974,
        images: ['images/main/winlines/winline3.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 540,
        y: 144,
        width: 80,
        height: 45,
        scale: 0.27707929337055426,
        images: ['images/main/winlines/winline4.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 640,
        y: 144,
        width: 80,
        height: 45,
        scale: 0.27707929337055426,
        images: ['images/main/winlines/winline5.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 240,
        y: 197.5,
        width: 80,
        height: 45,
        scale: 0.27707929337055426,
        images: ['images/main/winlines/winline6.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 340,
        y: 197.5,
        width: 80,
        height: 45,
        scale: 0.27707929337055426,
        images: ['images/main/winlines/winline7.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 440,
        y: 197.5,
        width: 80,
        height: 45,
        scale: 0.27707929337055426,
        images: ['images/main/winlines/winline8.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 540,
        y: 197.5,
        width: 80,
        height: 45,
        scale: 0.27707929337055426,
        images: ['images/main/winlines/winline9.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 640,
        y: 197.5,
        width: 80,
        height: 45,
        scale: 0.27707929337055426,
        images: ['images/main/winlines/winline10.png'],
      },
      {
        name: 'PaytableEntity-lines-describe-text',
        type: 'Text',
        x: 212.55,
        y: 358.1,
        width: 534.18,
        height: 94.665,
        text: 'payPaytable',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 534.18,
        },
      },
      {
        name: '',
        type: 'Image',
        x: 540,
        y: 250,
        width: 80,
        height: 45,
        scale: 0.27707929337055426,
        images: ['images/main/winlines/winline14.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 640,
        y: 250,
        width: 80,
        height: 45,
        scale: 0.27758768177929855,
        images: ['images/main/winlines/winline15.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 240,
        y: 305,
        width: 80,
        height: 45,
        scale: 0.27707929337055426,
        images: ['images/main/winlines/winline16.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 340,
        y: 305,
        width: 80,
        height: 45,
        scale: 0.27707929337055426,
        images: ['images/main/winlines/winline17.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 440,
        y: 305,
        width: 80,
        height: 45,
        scale: 0.27758768177929855,
        images: ['images/main/winlines/winline18.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 540,
        y: 305,
        width: 80,
        height: 45,
        scale: 0.2778909231230974,
        images: ['images/main/winlines/winline19.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 640,
        y: 305,
        width: 80,
        height: 45,
        scale: 0.2778909231230974,
        images: ['images/main/winlines/winline20.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 340,
        y: 250,
        width: 80,
        height: 45,
        scale: 0.27758768177929855,
        images: ['images/main/winlines/winline12.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 440,
        y: 250,
        width: 80,
        height: 45,
        scale: 0.27707929337055426,
        images: ['images/main/winlines/winline13.png'],
      },
      {
        name: 'bg',
        type: 'Graphics',
        x: 238,
        y: 60,
        width: 485,
        height: 394,
        alpha: 0.01,
      },
      {
        name: '',
        type: 'Image',
        x: 238.58,
        y: 250.75,
        width: 80,
        height: 45,
        scale: 0.27707929337055426,
        images: ['images/main/winlines/winline11.png'],
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -210,
        y: 100,
        scale: 1,
      },
    },
  },
  {
    name: 'GameRulesEntity',
    objects: [
      {
        name: 'GameRulesEntity-text',
        type: 'Text',
        x: 218,
        y: 35.65,
        width: 524,
        height: 40,
        text: 'rulesHeader',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 40,
          align: 'center',
          valign: 'top',
          fill: '#ff9900',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-additional-text',
        type: 'Text',
        x: 211.95,
        y: 3071.17,
        width: 524,
        height: 40,
        text: 'additional',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-additional-describe-text',
        type: 'Text',
        x: 211.95,
        y: 3112.67,
        width: 524,
        height: 40,
        text: 'additionalDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-generated-text',
        type: 'Text',
        x: 211.95,
        y: 3174.67,
        width: 524,
        height: 40,
        text: 'generated',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-generated-describe-text',
        type: 'Text',
        x: 211.95,
        y: 3213.17,
        width: 524,
        height: 40,
        text: 'generatedDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-menu-text',
        type: 'Text',
        x: 254.95,
        y: 2637.29,
        width: 461,
        height: 40,
        text: 'menu',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 461,
        },
      },
      {
        name: 'GameRulesEntity-home-text',
        type: 'Text',
        x: 254.95,
        y: 2695.29,
        width: 461,
        height: 40,
        text: 'home',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 461,
        },
      },
      {
        name: 'GameRulesEntity-cashier-text',
        type: 'Text',
        x: 254.95,
        y: 2753.29,
        width: 461,
        height: 40,
        text: 'cashier',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 461,
        },
      },
      {
        name: 'GameRulesEntity-game-rules-text',
        type: 'Text',
        x: 254.95,
        y: 2811.29,
        width: 461,
        height: 40,
        text: 'gameRules',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 461,
        },
      },
      {
        name: 'GameRulesEntity-paytable-text',
        type: 'Text',
        x: 254.95,
        y: 2869.99,
        width: 461,
        height: 40,
        text: 'paytable',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 461,
        },
      },
      {
        name: 'GameRulesEntity-game-settings-text',
        type: 'Text',
        x: 254.95,
        y: 2929.02,
        width: 461,
        height: 40,
        text: 'gameSettings',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 461,
        },
      },
      {
        name: 'scroll',
        type: 'Graphics',
        x: 0,
        y: 0,
        width: 960,
        height: 3229.825,
        alpha: 0,
      },
      {
        name: 'GameRulesEntity-button-functions-text',
        type: 'Text',
        x: 215.19,
        y: 2353.57,
        width: 524,
        height: 31.335,
        text: 'buttonFunctions',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-about-game-text',
        type: 'Text',
        x: 217.93,
        y: 85.13,
        width: 524,
        height: 40,
        text: 'about',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-about-describe-text',
        type: 'Text',
        x: 217.93,
        y: 131.46,
        width: 524,
        height: 40,
        text: 'aboutDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-return-player-text',
        type: 'Text',
        x: 217.93,
        y: 192.09,
        width: 524,
        height: 40,
        text: 'return',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-return-player-describe-text',
        type: 'RtpText',
        x: 218.58,
        y: 226.89,
        width: 524,
        height: 40,
        text: 'returnDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-how-to-play-text',
        type: 'Text',
        x: 218.91,
        y: 502.83,
        width: 524,
        height: 40,
        text: 'howPlay',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-how-to-play-describe-text',
        type: 'Text',
        x: 222.07,
        y: 541.66,
        width: 524,
        height: 40,
        text: 'howPlayDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-scatter-title-text',
        type: 'Text',
        x: 217.93,
        y: 639.37,
        width: 524,
        height: 40,
        text: 'scatter',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-scatter-describe-text',
        type: 'Text',
        x: 232.3,
        y: 656.5,
        width: 521.24,
        height: 73.025,
        text: 'scatterDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 521.24,
        },
      },
      {
        name: 'GameRulesEntity-wild-describe-text',
        type: 'Text',
        x: 222.72,
        y: 800.6,
        width: 534.475,
        height: 45.5,
        text: 'wildDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 534.475,
        },
      },
      {
        name: 'GameRulesEntity-freespins-text',
        type: 'Text',
        x: 217.95,
        y: 907.06,
        width: 524,
        height: 24.85,
        text: 'freespins',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-freespins-describe-text',
        type: 'Text',
        x: 217.95,
        y: 926.03,
        width: 524,
        height: 23.335,
        text: 'freespinsDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-pays-text',
        type: 'Text',
        x: 217.93,
        y: 257.55,
        width: 524,
        height: 40,
        text: 'pays',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-freespin-title-text',
        type: 'Text',
        x: 208.88,
        y: 1070.58,
        width: 524,
        height: 40,
        text: 'freespinsGameRules',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-bet-text',
        type: 'Text',
        x: 210.88,
        y: 1561.08,
        width: 524,
        height: 40,
        text: 'betGame',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-bet-describe-text',
        type: 'Text',
        x: 210.88,
        y: 1603.5,
        width: 524,
        height: 40,
        text: 'betGameDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-startstop-text',
        type: 'Text',
        x: 213.39,
        y: 1673.25,
        width: 524,
        height: 40,
        text: 'startStop',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-desktopv-text',
        type: 'Text',
        x: 213.39,
        y: 1851.81,
        width: 524,
        height: 40,
        text: 'desktopVersion',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-keyboard-text',
        type: 'Text',
        x: 212.72,
        y: 2195.09,
        width: 524,
        height: 40,
        text: 'keyboard',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-keyboard-describe-text',
        type: 'Text',
        x: 212.72,
        y: 2251.02,
        width: 524,
        height: 40,
        text: 'keyboardDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-keyboard3-describe-text',
        type: 'Text',
        x: 212.72,
        y: 2295.02,
        width: 524,
        height: 40,
        text: 'keyboardDescribeE',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-pays4-describe-text',
        type: 'Text',
        x: 218,
        y: 451.89,
        width: 524,
        height: 53.665,
        text: 'paysDescribeE',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-pays3-describe-text',
        type: 'Text',
        x: 218,
        y: 420.89,
        width: 524,
        height: 53.665,
        text: 'paysDescribeD',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-pays2-describe-text',
        type: 'Text',
        x: 217.93,
        y: 339.72,
        width: 524,
        height: 40,
        text: 'paysDescribeP',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-pays-describe-text',
        type: 'Text',
        x: 217.93,
        y: 295.72,
        width: 524,
        height: 40,
        text: 'paysDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-startstop-describe-text',
        type: 'Text',
        x: 213.39,
        y: 1726.67,
        width: 524,
        height: 40,
        text: 'startStopDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-startstop2-describe-text',
        type: 'Text',
        x: 213.39,
        y: 1786.17,
        width: 524,
        height: 40,
        text: 'startStopDescribeD',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-desktopv-describe-text',
        type: 'Text',
        x: 213.39,
        y: 1902.67,
        width: 524,
        height: 40,
        text: 'desktopVersionDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-desktopv2-describe-text',
        type: 'Text',
        x: 213.39,
        y: 1957.67,
        width: 524,
        height: 40,
        text: 'desktopVersionDescribeD',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-hot-features-text',
        type: 'Text',
        x: 217.95,
        y: 540.16,
        width: 524,
        height: 40,
        context: { jackpot: true },
        text: 'hotFeatures',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-jackpot-text',
        type: 'Text',
        x: 217.95,
        y: 581.16,
        width: 524,
        height: 40,
        context: { jackpot: true },
        text: 'jackpot',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-jackpot-describe-text',
        type: 'Text',
        x: 217.95,
        y: 601,
        width: 524,
        height: 40,
        context: { jackpot: true },
        text: 'jackpotDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-hot-features-text',
        type: 'Text',
        x: 217.95,
        y: 594.9,
        width: 524,
        height: 40,
        context: { jackpot: false },
        text: 'hotFeatures',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-spin-describe-text',
        type: 'Text',
        x: 251.16,
        y: 2555.55,
        width: 134.335,
        height: 62.335,
        text: 'spinDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 134.335,
        },
      },
      {
        name: 'GameRulesEntity-spin-text',
        type: 'Text',
        x: 274.15,
        y: 2504.55,
        width: 86.335,
        height: 29.835,
        text: 'spin',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 86.335,
        },
      },
      {
        name: 'GameRulesEntity-bet-header-text',
        type: 'Text',
        x: 583.89,
        y: 2505.28,
        width: 86.335,
        height: 29.835,
        text: 'betHeaderRules',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 86.335,
        },
      },
      {
        name: 'GameRulesEntity-bet-header-describe-text',
        type: 'Text',
        x: 560.55,
        y: 2553.11,
        width: 134.335,
        height: 72.165,
        text: 'betHeaderDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 134.335,
        },
      },
      {
        name: 'GameRulesEntity-autoplay-text',
        type: 'Text',
        x: 398.68,
        y: 2504.69,
        width: 131.335,
        height: 29.835,
        text: 'startStopBtn',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 131.335,
        },
      },
      {
        name: 'GameRulesEntity-autoplay-describe-text',
        type: 'Text',
        x: 398.01,
        y: 2555.69,
        width: 129.665,
        height: 69.335,
        text: 'startStopBtnDescribe',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 129.665,
        },
      },
      {
        name: '',
        type: 'Image',
        x: 431,
        y: 2419.05,
        width: 70,
        height: 70,
        scale: 0.2692307692307692,
        images: ['images/main/rules/spin-1.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 281,
        y: 2419.05,
        width: 70,
        height: 70,
        scale: 0.2692307692307692,
        images: ['images/main/rules/spin-0.png'],
      },
      {
        name: '',
        type: 'Image',
        x: 593,
        y: 2419.05,
        width: 70,
        height: 70,
        scale: 0.5,
        images: ['images/main/rules/bet-button-0.png'],
      },
      {
        name: 'GameRulesEntity-mobile-describe-text',
        type: 'Text',
        x: 213,
        y: 2084.84,
        width: 524,
        height: 55,
        text: 'leftHandModeDescription',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-wild-text',
        type: 'Text',
        x: 217.5,
        y: 783.98,
        width: 524,
        height: 23.335,
        text: 'wild',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'HISTORY - tap to view your latest game bets and payout',
        type: 'Text',
        x: 254.5,
        y: 2990.22,
        width: 400,
        height: 29.835,
        text: 'history',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 400,
        },
      },
      {
        name: 'GameRulesEntity-mobile-text',
        type: 'Text',
        x: 218,
        y: 2033.22,
        width: 524,
        height: 40,
        text: 'mobileVersion',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-freespin1-describe-text',
        type: 'Text',
        x: 210.5,
        y: 1131.47,
        width: 524,
        height: 60.665,
        text: 'freespinsGameRulesD',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-freespin2-describe-text',
        type: 'Text',
        x: 210.5,
        y: 1192.31,
        width: 524,
        height: 60.665,
        text: 'freespinsGameRulesE',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-freespin3-describe-text',
        type: 'Text',
        x: 210.5,
        y: 1254.31,
        width: 524,
        height: 60.665,
        text: 'freespinsGameRulesS',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-freespin4-describe-text',
        type: 'Text',
        x: 210.5,
        y: 1361.6,
        width: 524,
        height: 39.665,
        text: 'freespinsGameRulesC',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-freespin5-describe-text',
        type: 'Text',
        x: 210.5,
        y: 1402.81,
        width: 524,
        height: 50.665,
        text: 'freespinsGameRulesR',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
      {
        name: 'GameRulesEntity-freespin6-describe-text',
        type: 'Text',
        x: 210.5,
        y: 1465.31,
        width: 524,
        height: 46.665,
        text: 'freespinsGameRulesI',
        style: {
          font: 'Aeroport Light',
          fontFamily: 'Aeroport Light',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 16,
          align: 'center',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 524,
        },
      },
    ],
    properties: {},
    orientation: {
      land: {
        x: 0,
        y: 0,
        scale: 1,
      },
      port: {
        x: -210,
        y: 100,
        scale: 1,
      },
    },
  },
  {
    name: 'SettingsEntity',
    objects: [
      {
        name: 'settings',
        type: 'Text',
        width: 400,
        height: 28.335,
        text: 'settings',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 400,
        },
        orientation: {
          land: {
            x: 280.325,
            y: 62.665,
          },
          port: {
            x: 64,
            y: 96,
          },
        },
      },
      {
        name: 'space',
        type: 'ToggleButton',
        width: 60,
        height: 30,
        hitzone: 3,
        runtime: { platform: 'desktop' },
        scale: 0.49043062200956933,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 616,
            y: 224,
          },
          port: {
            x: 401.66,
            y: 363.34,
          },
        },
      },
      {
        name: 'space',
        type: 'Text',
        width: 303.485,
        height: 27.5,
        runtime: { platform: 'desktop' },
        text: 'space',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 303.485,
        },
        orientation: {
          port: {
            x: 64.665,
            y: 367.915,
          },
          land: {
            x: 280,
            y: 224,
          },
        },
      },
      {
        name: 'sound',
        type: 'ToggleButton',
        width: 60,
        height: 30,
        hitzone: 3,
        scale: 0.49043062200956933,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 616,
            y: 176,
          },
          port: {
            x: 403,
            y: 296,
          },
        },
      },
      {
        name: 'sound',
        type: 'Text',
        width: 303.485,
        height: 27.5,
        text: 'sound',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 303.485,
        },
        orientation: {
          port: {
            x: 64,
            y: 298.085,
          },
          land: {
            x: 280,
            y: 176,
          },
        },
      },
      {
        name: 'left',
        type: 'ToggleButton',
        width: 60,
        height: 30,
        hitzone: 3,
        runtime: { platform: 'mobile,tablet' },
        scale: 0.49043062200956933,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 616,
            y: 224,
          },
          port: {
            x: 401,
            y: 363,
          },
        },
      },
      {
        name: 'left',
        type: 'Text',
        width: 303.485,
        height: 27.5,
        runtime: { platform: 'mobile,tablet' },
        text: 'leftHand',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 303.485,
        },
        orientation: {
          port: {
            x: 65,
            y: 371,
          },
          land: {
            x: 280,
            y: 224,
          },
        },
      },
      {
        name: 'turbo',
        type: 'Text',
        width: 329,
        height: 27.5,
        text: 'turboModeSettings',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 329,
        },
        orientation: {
          land: {
            x: 280,
            y: 128,
          },
          port: {
            x: 61,
            y: 229,
          },
        },
      },
      {
        name: 'turbo',
        type: 'ToggleButton',
        width: 60,
        height: 30,
        hitzone: 3,
        scale: 0.49043062200956933,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 616,
            y: 126,
          },
          port: {
            x: 400,
            y: 232,
          },
        },
      },
      {
        name: 'fps',
        type: 'Text',
        width: 329,
        height: 27.5,
        text: 'fps',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 329,
        },
        orientation: {
          land: {
            x: 280,
            y: 272,
          },
          port: {
            x: 65,
            y: 444,
          },
        },
      },
      {
        name: 'cheat',
        type: 'Text',
        width: 329,
        height: 27.5,
        context: { debug: true },
        text: 'cheat',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 329,
        },
        orientation: {
          land: {
            x: 280,
            y: 320,
          },
          port: {
            x: 65,
            y: 517,
          },
        },
      },
      {
        name: 'cheat',
        type: 'ToggleButton',
        width: 60,
        height: 30,
        context: { debug: true },
        hitzone: 3,
        scale: 0.49043062200956933,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 616,
            y: 314.5,
          },
          port: {
            x: 401.5,
            y: 517,
          },
        },
      },
      {
        name: 'fps',
        type: 'ToggleButton',
        width: 60,
        height: 30,
        hitzone: 3,
        scale: 0.49043062200956933,
        images: [
          'images/icons/cookie-toggle-0.png',
          'images/icons/cookie-toggle-1.png',
        ],
        orientation: {
          land: {
            x: 616,
            y: 269,
          },
          port: {
            x: 401.5,
            y: 444,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'MenuEntity',
    objects: [
      {
        name: 'menuhome',
        type: 'ImageButton',
        width: 40,
        height: 40,
        direction: true,
        hitzone: 4,
        scale: 0.5,
        images: ['images/icons/menu-home.png'],
        orientation: {
          land: {
            x: 55,
            y: 70,
          },
          port: {
            x: 107.5,
            y: 778.75,
            v: 1,
          },
        },
      },
      {
        name: 'menu-gamerules',
        type: 'RadioButton',
        width: 40,
        height: 40,
        direction: true,
        hitzone: 4,
        scale: 0.5,
        images: [
          'images/icons/menu-info-0.png',
          'images/icons/menu-info-1.png',
        ],
        orientation: {
          land: {
            x: 55,
            y: 180,
          },
          port: {
            x: 237.5,
            y: 778.75,
            v: 1,
          },
        },
      },
      {
        name: 'menu-paytable',
        type: 'RadioButton',
        width: 40,
        height: 40,
        direction: true,
        hitzone: 4,
        scale: 0.5,
        images: [
          'images/icons/menu-paytable-0.png',
          'images/icons/menu-paytable-1.png',
        ],
        orientation: {
          land: {
            x: 55,
            y: 235,
          },
          port: {
            x: 302.5,
            y: 778.75,
            v: 1,
          },
        },
      },
      {
        name: 'menucashier',
        type: 'ImageButton',
        width: 40,
        height: 40,
        direction: true,
        hitzone: 4,
        scale: 0.5,
        images: ['images/icons/menu-cashier-1.png'],
        orientation: {
          land: {
            x: 55,
            y: 125,
          },
          port: {
            x: 172.5,
            y: 778.75,
            v: 1,
          },
        },
      },
      {
        name: 'menu-settings',
        type: 'RadioButton',
        width: 40,
        height: 40,
        direction: true,
        hitzone: 4,
        scale: 0.5,
        images: [
          'images/icons/menu-settings-0.png',
          'images/icons/menu-settings-1.png',
        ],
        orientation: {
          land: {
            x: 55,
            y: 290,
          },
          port: {
            x: 367.5,
            y: 778.75,
            v: 1,
          },
        },
      },
      {
        name: 'menuhistory',
        type: 'ImageButton',
        width: 40,
        height: 40,
        direction: true,
        hitzone: 3,
        scale: 0.5,
        images: ['images/icons/menu-history-1.png'],
        orientation: {
          land: {
            x: 55,
            y: 345,
          },
          port: {
            x: 432.5,
            y: 778.75,
            v: 1,
          },
        },
      },
      {
        name: 'ui-menu',
        type: 'RadioButton',
        width: 50,
        height: 50,
        deselect: true,
        direction: true,
        hitzone: 2,
        scale: 0.5,
        images: [
          'images/icons/menu-hamburger-0.png',
          'images/icons/menu-hamburger-1.png',
        ],
        orientation: {
          land: {
            x: 50,
            y: 397,
          },
          port: {
            x: 26.5,
            y: 775,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'UIRegularEntity',
    objects: [
      {
        name: 'spin',
        type: 'SpinButton',
        width: 128.335,
        height: 128.335,
        direction: true,
        scale: 0.49359615384615385,
        images: [
          'images/icons/spin-0.png',
          'images/icons/spin-1.png',
        ],
        orientation: {
          land: {
            x: 842.17,
            y: 203,
          },
          port: {
            x: 208.23,
            y: 716,
            v: 1,
          },
        },
      },
      {
        name: 'ui-bet',
        type: 'RadioButton',
        width: 67.835,
        height: 67.835,
        deselect: true,
        direction: true,
        hitzone: 3,
        scale: 0.48453571428571424,
        images: [
          'images/icons/bet-button-0.png',
          'images/icons/bet-button-1.png',
        ],
        orientation: {
          port: {
            x: 115.5,
            y: 763.5,
            v: 1,
          },
          land: {
            x: 873.34,
            y: 349,
          },
        },
      },
      {
        name: 'ui-menu',
        type: 'RadioButton',
        width: 50,
        height: 50,
        deselect: true,
        direction: true,
        hitzone: 6,
        scale: 0.5,
        images: [
          'images/icons/menu-hamburger-0.png',
          'images/icons/menu-hamburger-1.png',
        ],
        orientation: {
          land: {
            x: 50,
            y: 397,
          },
          port: {
            x: 26.5,
            y: 775.5,
            v: 1,
          },
        },
      },
      {
        name: 'autostop',
        type: 'ImageButton',
        width: 70,
        height: 70,
        direction: true,
        scale: 0.4430379746835443,
        images: ['images/icons/stop-autoplay.png'],
        orientation: {
          port: {
            x: 454.5,
            y: 763,
            v: 1,
          },
          land: {
            x: 867.83,
            y: 27,
          },
        },
      },
      {
        name: 'ui-automenu',
        type: 'RadioButton',
        width: 70,
        height: 70,
        deselect: true,
        direction: true,
        scale: 0.5,
        images: [
          'images/icons/auto-menu-0.png',
          'images/icons/auto-menu-1.png',
        ],
        orientation: {
          land: {
            x: 872.67,
            y: 32,
          },
          port: {
            x: 454.5,
            y: 763,
            v: 1,
          },
        },
      },
      {
        name: 'autospin-text',
        type: 'AutoCountText',
        width: 50,
        height: 50,
        direction: true,
        text: '10',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 26,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 50,
        },
        orientation: {
          land: {
            x: 881.165,
            y: 241,
          },
          port: {
            x: 246.16,
            y: 754,
            v: 1,
          },
        },
      },
      {
        name: 'you-win',
        type: 'WinText',
        width: 206,
        height: 17.5,
        text: '$5.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 206,
        },
        orientation: {
          port: {
            x: 163.5,
            y: 892.5,
            v: 1,
          },
          land: {
            x: 385,
            y: 480.5,
            v: 1,
          },
        },
      },
      {
        name: 'free-bet-count',
        type: 'FreeBetLeft',
        width: 100,
        height: 17.5,
        text: '$5,00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
        },
        orientation: {
          land: {
            x: 702.5,
            y: 480.5,
            v: 1,
          },
          port: {
            x: 338.595,
            y: 892.5,
            v: 1,
          },
        },
      },
      {
        name: 'you-win',
        type: 'Text',
        width: 135,
        height: 17.5,
        text: 'win',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 135,
        },
        orientation: {
          port: {
            x: 198,
            y: 868.5,
            v: 1,
          },
          land: {
            x: 418.895,
            y: 463,
            v: 1,
          },
        },
      },
      {
        name: 'free-bet-text',
        type: 'FreeBetText',
        width: 135,
        height: 17.5,
        text: 'freeBetLeft',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'center',
          valign: 'center',
          fill: '#8c8a8b',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
        },
        orientation: {
          land: {
            x: 682.115,
            y: 463,
            v: 1,
          },
          port: {
            x: 317.45,
            y: 869.23,
            v: 1,
          },
        },
      },
      {
        name: 'sound-bg',
        type: 'Image',
        width: 70,
        height: 70,
        direction: true,
        scale: 0.5185185185185185,
        images: ['images/underlay/circle-small.png'],
        orientation: {
          land: {
            x: 872,
            y: 118,
          },
          port: {
            x: 353,
            y: 763,
            v: 1,
          },
        },
      },
      {
        name: 'sound',
        type: 'ToggleButton',
        width: 52.71,
        height: 45.18,
        direction: true,
        scale: 0.753,
        images: [
          'images/icons/sound-0.png',
          'images/icons/sound-1.png',
        ],
        orientation: {
          land: {
            x: 880.56,
            y: 129.82,
          },
          port: {
            x: 361.13,
            y: 775,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'UIFreespinsEntity',
    objects: [
      {
        name: 'frame-spin',
        type: 'Image',
        width: 130,
        height: 130,
        direction: true,
        scale: 0.5,
        images: ['images/icons/spin-0.png'],
        orientation: {
          land: {
            x: 842.17,
            y: 203,
          },
          port: {
            x: 206.67,
            y: 713.5,
            v: 1,
          },
        },
      },
      {
        name: 'freespinsCount',
        type: 'FreespinsCountText',
        width: 124,
        height: 124,
        direction: true,
        text: '15',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 27.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 124,
        },
        orientation: {
          land: {
            x: 844.62,
            y: 205.42,
          },
          port: {
            x: 210.335,
            y: 717.165,
            v: 1,
          },
        },
      },
      {
        name: 'total-name-p',
        type: 'Text',
        width: 153.335,
        height: 17.5,
        text: 'youWin',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'center',
          valign: 'center',
          fill: '#8c8a8b',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 153.335,
        },
        orientation: {
          port: {
            x: 264,
            y: 868.5,
            v: 1,
          },
        },
      },
      {
        name: 'total-name',
        type: 'Text',
        width: 150,
        height: 17.5,
        text: 'youWin',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'center',
          valign: 'center',
          fill: '#8c8a8b',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 150,
        },
        orientation: {
          land: {
            x: 675.21,
            y: 463,
            v: 1,
          },
        },
      },
      {
        name: 'total-value-p',
        type: 'FreespinsTotalWinText',
        width: 241,
        height: 17.5,
        text: '100.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 241,
        },
        orientation: {
          port: {
            x: 223,
            y: 892.5,
            v: 1,
          },
        },
      },
      {
        name: 'total-value',
        type: 'FreespinsTotalWinText',
        width: 206,
        height: 17.5,
        text: '100.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 206,
        },
        orientation: {
          land: {
            x: 645.64,
            y: 480.5,
            v: 1,
          },
        },
      },
      {
        name: 'you-win-text-fs',
        type: 'Text',
        width: 100,
        height: 17.5,
        text: 'youWinName',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'center',
          valign: 'center',
          fill: '#8c8a8b',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 100,
        },
        orientation: {
          land: {
            x: 192,
            y: 463.565,
            v: 1,
          },
          port: {
            x: 152,
            y: 868.5,
            v: 1,
          },
        },
      },
      {
        name: 'you-win-fs',
        type: 'WinText',
        width: 217.67,
        height: 17.5,
        text: '$5.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 217.67,
        },
        orientation: {
          port: {
            x: 97.33,
            y: 892.5,
            v: 1,
          },
          land: {
            x: 134.565,
            y: 479.935,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'UIGeneralEntity',
    objects: [
      {
        name: 'bet-name',
        type: 'Text',
        width: 100,
        height: 17.5,
        text: 'bet',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'right',
          valign: 'center',
          fill: '#8c8a8b',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 100,
        },
        orientation: {
          land: {
            x: 843.5,
            y: 463,
            v: 1,
          },
        },
      },
      {
        name: 'balance-name',
        type: 'Text',
        width: 100,
        height: 17.5,
        text: 'balance',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'left',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 100,
        },
        orientation: {
          port: {
            x: 24,
            y: 868.5,
            v: 1,
          },
          land: {
            x: 19.75,
            y: 463,
            v: 1,
          },
        },
      },
      {
        name: 'bet-value',
        type: 'BetText',
        width: 175.76,
        height: 17.5,
        text: '$ 2',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13.5,
          align: 'right',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 175.76,
        },
        orientation: {
          land: {
            x: 767.075,
            y: 480.5,
            v: 1,
          },
        },
      },
      {
        name: 'balance-value',
        type: 'BalanceText',
        width: 214.325,
        height: 17.5,
        text: '100.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 214.325,
        },
        orientation: {
          port: {
            x: 24,
            y: 892.5,
            v: 1,
          },
          land: {
            x: 19.835,
            y: 480.5,
            v: 1,
          },
        },
      },
      {
        name: 'bet-name-p',
        type: 'Text',
        width: 100,
        height: 17.5,
        text: 'bet',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 17.5,
          align: 'right',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 100,
        },
        orientation: {
          port: {
            x: 424,
            y: 868.5,
            v: 1,
          },
        },
      },
      {
        name: 'bet-value-p',
        type: 'BetText',
        width: 175,
        height: 17.5,
        text: '100.00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 15,
          align: 'right',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 175,
        },
        orientation: {
          port: {
            x: 349,
            y: 892.5,
            v: 1,
          },
        },
      },
      {
        name: 'timer-clock',
        type: 'TimerText',
        width: 50,
        height: 17.5,
        text: '00:00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13,
          align: 'left',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 50,
        },
        orientation: {
          land: {
            x: 20,
            y: 510,
            v: 1,
          },
          port: {
            x: 24,
            y: 939,
            v: 1,
          },
        },
      },
      {
        name: 'timer-name',
        type: 'Text',
        width: 74.55,
        height: 17.5,
        text: 'timeElapsed',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 10,
          align: 'left',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 74.55,
        },
        orientation: {
          land: {
            x: 75,
            y: 510,
            v: 1,
          },
          port: {
            x: 75.175,
            y: 939,
            v: 1,
          },
        },
      },
      {
        name: 'net-balance',
        type: 'NetPosition',
        width: 81.945,
        height: 17.5,
        text: '',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 13,
          align: 'right',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 81.945,
        },
        orientation: {
          land: {
            x: 860.5,
            y: 510,
            v: 1,
          },
          port: {
            x: 440,
            y: 939,
            v: 1,
          },
        },
      },
      {
        name: 'net-name',
        type: 'Text',
        width: 75.175,
        height: 17.5,
        text: 'netPosition',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 10,
          align: 'right',
          valign: 'center',
          fill: '#8c8b8a',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 75.175,
        },
        orientation: {
          land: {
            x: 784,
            y: 510,
            v: 1,
          },
          port: {
            x: 363,
            y: 939,
            v: 1,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'FreespinsEndEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 960,
        height: 960,
        alpha: 1,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'BGpopup',
        type: 'Image',
        width: 1160,
        height: 1160,
        scale: 0.6041666666666666,
        images: ['images/main/freespins/fs-add-l+p.png'],
        orientation: {
          land: {
            x: -100,
            y: -280,
          },
          port: {
            x: -250,
            y: -100,
          },
        },
      },
      {
        name: 'freenspinsText',
        type: 'FreespinsTotalWinPopupText',
        width: 540,
        height: 61.485,
        fontBitmap: 'bitmap',
        letterSpacing: 35,
        text: '50.00',
        style: {
          font: 'bitmap',
          fontFamily: 'bitmap',
          fontWeight: 'bold',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 540,
        },
        orientation: {
          land: {
            x: 210,
            y: 278.76,
          },
          port: {
            x: 0,
            y: 504.395,
          },
        },
      },
      {
        name: 'freespinsText',
        type: 'Text',
        width: 389.5,
        height: 40.5,
        text: 'freenspinswon',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 31,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 389.5,
        },
        orientation: {
          land: {
            x: 287.25,
            y: 184.75,
          },
          port: {
            x: 78.95,
            y: 398.475,
          },
        },
      },
      {
        name: 'lapmTrigger',
        type: 'AnimationSpine',
        width: 1920,
        height: 1920,
        animation: 'lamp-back',
        oriented: false,
        spine: 'animations/spine/bonus_game_anims/lamp/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: -150,
            scale: 0.5,
          },
        },
      },
      {
        name: 'lapm',
        type: 'AnimationSpine',
        width: 1920,
        height: 1920,
        animation: 'lamp-back',
        oriented: false,
        spine: 'animations/spine/bonus_game_anims/lamp/skeleton.json',
        orientation: {
          port: {
            x: -225,
            y: -100,
            scale: 0.5,
          },
        },
      },
      {
        name: 'endFreespin',
        type: 'ImageButton',
        width: 142.5,
        height: 59,
        hitzone: 6,
        scale: 0.5,
        images: ['images/icons/end-free-spin-button.png'],
        orientation: {
          land: {
            x: 409.2,
            y: 388.92,
          },
          port: {
            x: 208.73,
            y: 720.5,
          },
        },
      },
      {
        name: 'endFreespinText',
        type: 'Text',
        width: 136.67,
        height: 52.32,
        text: 'endFreeSpinButton',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 22.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 136.67,
        },
        orientation: {
          land: {
            x: 412.66,
            y: 392.98,
          },
        },
      },
      {
        name: 'endFreespinText-p',
        type: 'Text',
        width: 110.815,
        height: 48.405,
        text: 'endFreeSpinButton',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 22.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 110.815,
        },
        orientation: {
          port: {
            x: 224.205,
            y: 726.735,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'FreespinsStartEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 960,
        height: 960,
        alpha: 1,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'BGpopup',
        type: 'Image',
        width: 1160,
        height: 1160,
        scale: 0.6041666666666666,
        images: ['images/main/freespins/fs-add-l+p.png'],
        orientation: {
          land: {
            x: -100,
            y: -280,
          },
          port: {
            x: -250,
            y: -100,
          },
        },
      },
      {
        name: 'lapmTrigger',
        type: 'AnimationSpine',
        width: 1920,
        height: 1920,
        animation: 'lamp-back',
        oriented: false,
        spine: 'animations/spine/bonus_game_anims/lamp/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: -150,
            scale: 0.5,
          },
          port: {
            x: -225,
            y: -100,
            scale: 0.5,
          },
        },
      },
      {
        name: 'shotsIdle',
        type: 'AnimationSpine',
        width: 1920,
        height: 1920,
        animation: 'idle',
        oriented: false,
        spine: 'animations/spine/bonus_game_anims/shots/skeleton.json',
        orientation: {
          land: {
            x: 4,
            y: -232,
            scale: 0.5,
          },
          port: {
            x: -160,
            y: -44,
            scale: 0.5,
          },
        },
      },
      {
        name: 'FSTitle',
        type: 'Image',
        width: 181.5,
        height: 153.5,
        scale: 0.5,
        images: ['images/main/freespins/free-spins.png'],
        orientation: {
          land: {
            x: 388.29,
            y: 185.62,
          },
        },
      },
      {
        name: 'FStitle',
        type: 'Image',
        width: 181.5,
        height: 153.5,
        scale: 0.5,
        images: ['images/main/freespins/free-spins.png'],
        orientation: {
          port: {
            x: 173.14,
            y: 391.68,
          },
        },
      },
      {
        name: 'startFreespin',
        type: 'ImageButton',
        width: 166,
        height: 62.5,
        scale: 0.5,
        images: ['images/main/freespins/btn.png'],
        orientation: {
          land: {
            x: 394.28,
            y: 426.58,
          },
          port: {
            x: 184,
            y: 640,
          },
        },
      },
      {
        name: 'startText',
        type: 'Text',
        width: 108.72,
        height: 41.335,
        letterSpacing: 1,
        text: 'starttext',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'bold',
          fontStyle: 'normal',
          fontSize: 25,
          align: 'center',
          valign: 'center',
          fill: '#2d2425',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 108.72,
        },
        orientation: {
          land: {
            x: 424,
            y: 433,
          },
          port: {
            x: 216.5,
            y: 650.5,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'FreespinsAddEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 960,
        height: 960,
        alpha: 1,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'BGpopup',
        type: 'Image',
        width: 1160,
        height: 1160,
        scale: 0.6041666666666666,
        images: ['images/main/freespins/fs-add-l+p.png'],
        orientation: {
          land: {
            x: -100,
            y: -280,
          },
          port: {
            x: -250,
            y: -100,
          },
        },
      },
      {
        name: 'lapm',
        type: 'TriggerSpine',
        width: 1920,
        height: 1920,
        animation: 'lamp-when-shoot',
        oriented: false,
        spine: 'animations/spine/bonus_game_anims/lamp/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: -150,
            scale: 0.5,
          },
          port: {
            x: -225,
            y: -100,
            scale: 0.5,
          },
        },
      },
      {
        name: 'shots',
        type: 'TriggerSpine',
        width: 1920,
        height: 1920,
        animation: 'animation',
        oriented: false,
        spine: 'animations/spine/bonus_game_anims/shots/skeleton.json',
        orientation: {
          port: {
            x: -160,
            y: -44,
            scale: 0.5,
          },
          land: {
            x: 4,
            y: -232,
            scale: 0.5,
          },
        },
      },
      {
        name: 'FSTitle',
        type: 'Image',
        width: 181.5,
        height: 153.5,
        scale: 0.5,
        images: ['images/main/freespins/free-spins.png'],
        orientation: {
          land: {
            x: 388.29,
            y: 185.62,
          },
        },
      },
      {
        name: 'FStitle',
        type: 'Image',
        width: 181.5,
        height: 153.5,
        scale: 0.5,
        images: ['images/main/freespins/free-spins.png'],
        orientation: {
          port: {
            x: 173.14,
            y: 391.68,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'TransitionBonusEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 960,
        height: 960,
        alpha: 1,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'transition',
        type: 'TransitionAnimation',
        width: 960,
        height: 960,
        animation: 'animation',
        scale: 0.5,
        spine: 'animations/spine/transition/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'ChoiseBonusEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 960,
        height: 960,
        alpha: 1,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'BGpopup',
        type: 'Image',
        width: 1160,
        height: 1160,
        scale: 0.6041666666666666,
        images: ['images/main/freespins/fs-add-l+p.png'],
        orientation: {
          land: {
            x: -100,
            y: -280,
          },
          port: {
            x: -250,
            y: -100,
          },
        },
      },
      {
        name: 'lapmTrigger',
        type: 'AnimationSpine',
        width: 1920,
        height: 1920,
        animation: 'lamp-back',
        oriented: false,
        spine: 'animations/spine/bonus_game_anims/lamp/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: -150,
            scale: 0.5,
          },
        },
      },
      {
        name: 'lapm',
        type: 'AnimationSpine',
        width: 1920,
        height: 1920,
        animation: 'lamp-back',
        oriented: false,
        spine: 'animations/spine/bonus_game_anims/lamp/skeleton.json',
        orientation: {
          port: {
            x: -225,
            y: -100,
            scale: 0.5,
          },
        },
      },
      {
        name: 'popup',
        type: 'ChooseSpinePopup',
        width: 960,
        height: 960,
        animation: 'gun-start',
        animations: [
          '-multiplier',
          '-respin',
          '-royals',
          '-x2',
          '-x3',
        ],
        buttons: 'aim_01,aim_02,aim_03,aim_04,aim_05',
        loopAnimation: 'tap',
        scale: 0.3,
        spine: 'animations/spine/gunchoose/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
    ],
    properties: {},
  },
  {
    name: 'FreebetEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 960,
        height: 960,
        alpha: 0.8,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'bg',
        type: 'Image',
        width: 370,
        height: 255,
        scale: 0.5,
        images: ['images/underlay/free-bet-bg.png'],
        orientation: {
          land: {
            x: 295,
            y: 140.24,
          },
        },
      },
      {
        name: 'bg-p',
        type: 'Image',
        width: 370,
        height: 255,
        scale: 0.5,
        images: ['images/underlay/free-bet-bg.png'],
        orientation: {
          port: {
            x: 95,
            y: 315.36,
          },
        },
      },
      {
        name: 'FB-CLOSE',
        type: 'RadioButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 424.84,
            y: 321.17,
          },
          port: {
            x: 223.29,
            y: 493.22,
          },
        },
      },
      {
        name: 'text',
        type: 'Text',
        width: 112.415,
        height: 51.585,
        text: 'OK',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 112.415,
        },
        orientation: {
          land: {
            x: 424.665,
            y: 323,
          },
          port: {
            x: 223.79,
            y: 494.86,
          },
        },
      },
      {
        name: 'fb-end',
        type: 'FreeBetWinText',
        width: 370.835,
        height: 74.425,
        text: 'freeBetTotalWin',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32.5,
          align: 'center',
          valign: 'center',
          fill: '#f99531',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 370.835,
        },
        orientation: {
          land: {
            x: 293.915,
            y: 224.79,
          },
          port: {
            x: 94.94,
            y: 396.715,
          },
        },
      },
      {
        name: 'fb-end-popup',
        type: 'PopupText',
        width: 366.57,
        height: 79.14,
        text: 'freeBetEnd',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 21.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 366.57,
        },
        orientation: {
          land: {
            x: 297.38,
            y: 139.765,
          },
          port: {
            x: 95.285,
            y: 317.575,
          },
        },
      },
      {
        name: 'fb-add',
        type: 'FreeBetCountText',
        width: 370.835,
        height: 74.425,
        text: 'freeBetsCount',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 32.5,
          align: 'center',
          valign: 'center',
          fill: '#f99531',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 370.835,
        },
        orientation: {
          land: {
            x: 293.915,
            y: 224.79,
          },
          port: {
            x: 94.94,
            y: 398.5,
          },
        },
      },
      {
        name: 'fb-add-popup',
        type: 'PopupText',
        width: 370.835,
        height: 74.425,
        text: 'congrats',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 21.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 370.835,
        },
        orientation: {
          land: {
            x: 294.835,
            y: 139.325,
          },
          port: {
            x: 95.93,
            y: 312.28,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'IntroScreenEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 960,
        height: 960,
        alpha: 1,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'BackgroundL',
        type: 'Image',
        width: 1309.295,
        height: 835.24,
        scale: 0.6818765252976191,
        images: ['images/init/splashscreen-l.jpeg'],
        orientation: {
          land: {
            x: -174,
            y: -164,
          },
        },
      },
      {
        name: 'BackgrounP',
        type: 'Image',
        width: 803.795,
        height: 1260,
        scale: 0.6562045918367347,
        images: ['images/init/splashscreen-p.jpeg'],
        orientation: {
          port: {
            x: -142,
            y: -166,
          },
        },
      },
      {
        name: 'close',
        type: 'GraphicsButton',
        width: 960,
        height: 960,
        alpha: 0,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'IntroScreenEntity-tap-to-play-text',
        type: 'Text',
        width: 960,
        height: 58.51,
        customStyle: 'intro',
        tween: 'introTween',
        text: 'tapPlay',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 30,
          align: 'center',
          valign: 'center',
          fill: '#e199ff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 960,
        },
        orientation: {
          land: {
            x: -0.44,
            y: 493.04,
          },
        },
      },
      {
        name: 'IntroScreenEntity-tap-to-play-port-text',
        type: 'Text',
        width: 540,
        height: 62.84,
        customStyle: 'intro',
        tween: 'introTween',
        text: 'tapPlay',
        style: {
          font: 'Aeroport Medium',
          fontFamily: 'Aeroport Medium',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 30,
          align: 'center',
          valign: 'center',
          fill: '#ff99ff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 540,
        },
        orientation: {
          port: {
            x: 2.805,
            y: 813.885,
          },
        },
      },
      {
        name: 'underloader',
        type: 'Image',
        width: 338,
        height: 12,
        scale: 0.5,
        images: ['../base/images/loader/loader-gray.png'],
        orientation: {
          land: {
            x: 304.25,
            y: 512.72,
          },
          port: {
            x: 104.32,
            y: 843.37,
          },
        },
      },
      {
        name: 'loaderline',
        type: 'Loader',
        width: 333,
        height: 8,
        scale: 0.5,
        images: ['../base/images/loader/loader-progress.png'],
        orientation: {
          land: {
            x: 305.49,
            y: 514.77,
          },
          port: {
            x: 106.73,
            y: 845.4,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'SoundPopupEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 960,
        height: 960,
        alpha: 0.8,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'sound-back',
        type: 'Image',
        width: 336,
        height: 173.42,
        scale: 0.5419364919354839,
        images: ['images/underlay/soundBack.png'],
        orientation: {
          land: {
            x: 309,
            y: 179.34,
          },
          port: {
            x: 108.5,
            y: 377,
          },
        },
      },
      {
        name: 'sound-1',
        type: 'ImageButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: ['images/icons/button-0.png'],
        orientation: {
          land: {
            x: 354,
            y: 249.5,
          },
          port: {
            x: 142,
            y: 448.5,
          },
        },
      },
      {
        name: 'sound-0',
        type: 'ImageButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: ['images/icons/button-0.png'],
        orientation: {
          land: {
            x: 493,
            y: 249.5,
          },
          port: {
            x: 304,
            y: 448,
          },
        },
      },
      {
        name: 'enable-sound',
        type: 'Text',
        width: 349.335,
        height: 38.165,
        text: 'soundQuestion',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 21.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 349.335,
        },
        orientation: {
          land: {
            x: 300,
            y: 199.5,
          },
          port: {
            x: 107.5,
            y: 391.335,
          },
        },
      },
      {
        name: 'sound-yes',
        type: 'Text',
        width: 54.5,
        height: 52.5,
        text: 'soundYes',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 54.5,
        },
        orientation: {
          land: {
            x: 400,
            y: 250,
          },
          port: {
            x: 177.665,
            y: 448,
          },
        },
      },
      {
        name: 'sound-no',
        type: 'Text',
        width: 54.5,
        height: 52.5,
        text: 'soundNo',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 54.5,
        },
        orientation: {
          land: {
            x: 535,
            y: 250,
          },
          port: {
            x: 344.665,
            y: 449,
          },
        },
      },
      {
        name: 'sound-yes-pic',
        type: 'Image',
        width: 24.025,
        height: 26.52,
        scale: 0.4058076923076923,
        images: ['images/icons/sound-1.png'],
        orientation: {
          land: {
            x: 367.09,
            y: 262.08,
          },
          port: {
            x: 152.17,
            y: 460.42,
          },
        },
      },
      {
        name: 'sound-no-pic',
        type: 'Image',
        width: 35,
        height: 30,
        scale: 0.5,
        images: ['images/icons/sound-0.png'],
        orientation: {
          land: {
            x: 505.17,
            y: 261,
          },
          port: {
            x: 316.5,
            y: 459.67,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'PopupEntity',
    objects: [
      {
        name: 'stretch',
        type: 'NoiseGraphics',
        width: 960,
        height: 960,
        alpha: 0.8,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'image',
        type: 'PopupButton',
        width: 113,
        height: 51.5,
        scale: 0.5143181818181819,
        images: [
          'images/icons/button-0.png',
          'images/icons/button-1.png',
        ],
        orientation: {
          land: {
            x: 418.17,
            y: 324.5,
          },
          port: {
            x: 221.5,
            y: 470,
          },
        },
      },
      {
        name: 'text',
        type: 'PopupButton',
        width: 112.415,
        height: 51.585,
        text: 'OK',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 20,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 112.415,
        },
        orientation: {
          land: {
            x: 418,
            y: 326.335,
          },
          port: {
            x: 222.005,
            y: 471.645,
          },
        },
      },
      {
        name: 'body',
        type: 'PopupText',
        width: 475.5,
        height: 168.425,
        text: 'NO INTERNET CONNECTION.\nPLEASE CHECK YOUR CONNECTION\nAND RELOAD THE GAME TO CONTINUE',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 21.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 475.5,
        },
        orientation: {
          land: {
            x: 241.5,
            y: 101.325,
          },
          port: {
            x: 37.005,
            y: 280.135,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'FullscreenEntity',
    objects: [
      {
        name: 'fullscreen',
        type: 'GraphicsButton',
        width: 960,
        height: 960,
        alpha: 0.5,
        resize: true,
        orientation: {
          land: {
            x: 0,
            y: -210,
          },
          port: {
            x: -210,
            y: 0,
          },
        },
      },
      {
        name: 'tapa',
        type: 'Image',
        width: 126,
        height: 212.5,
        runtime: {
          os: 'android',
          platform: 'mobile,tablet',
        },
        scale: 0.5,
        images: ['images/icons/fullscreen-1.png'],
        orientation: {
          land: {
            x: 423.67,
            y: 164,
          },
          port: {
            x: 213.5,
            y: 372.84,
          },
        },
      },
      {
        name: 'tap',
        type: 'AnimationSpine',
        width: 329,
        height: 471,
        runtime: {
          os: 'ios',
          platform: 'mobile,tablet',
        },
        spine: 'animations/spine/fullscreen/skeleton.json',
        orientation: {
          land: {
            x: 398,
            y: 147.5,
            scale: 0.5,
          },
          port: {
            x: 197,
            y: 357.5,
            scale: 0.5,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
  {
    name: 'LoadingEntity',
    objects: [
      {
        name: 'logoanim',
        type: 'LogoSpine',
        width: 960,
        height: 540,
        spine: 'brand/anim/skeleton.json',
        orientation: {
          land: {
            x: 0,
            y: 0,
          },
          port: {
            x: -410,
            y: 200,
          },
        },
      },
    ],
    properties: { parentGroup: 'INIT' },
  },
  {
    name: 'UIGeneralOverlayEntity',
    objects: [
      {
        name: 'intro-clock-l',
        type: 'ClockText',
        width: 54.765,
        height: 20.4,
        text: '00:00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14.5,
          align: 'center',
          valign: 'center',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 54.765,
        },
        orientation: {
          land: {
            x: 880.81,
            y: 4.53,
            v: -1,
          },
        },
      },
      {
        name: 'intro-clock-p',
        type: 'ClockText',
        width: 46.835,
        height: 15.835,
        text: '00:00',
        style: {
          font: 'Aeroport',
          fontFamily: 'Aeroport',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 14.5,
          align: 'left',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
          wordWrap: true,
          wordWrapWidth: 46.835,
        },
        orientation: {
          port: {
            x: 490.775,
            y: 3.42,
            h: 1,
            v: -1,
          },
        },
      },
      {
        name: 'game-name',
        type: 'Text',
        width: 233.115,
        height: 14.795,
        alpha: 0.5,
        force: false,
        text: 'gameName',
        style: {
          font: 'Druk Text Cy',
          fontFamily: 'Druk Text Cy',
          fontWeight: 'normal',
          fontStyle: 'normal',
          fontSize: 10,
          align: 'left',
          valign: 'top',
          fill: '#ffffff',
          dropShadow: true,
          dropShadowAlpha: 0.8,
          dropShadowBlur: 1,
          dropShadowDistance: 1,
        },
        orientation: {
          land: {
            x: 6.765,
            y: 0,
            h: -1,
            v: -1,
          },
          port: {
            x: 11.9,
            y: 4.41,
            h: -1,
            v: -1,
          },
        },
      },
    ],
    properties: { parentGroup: 'SPLASH' },
  },
]
